import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getUser } from '@shared/helpers/auth';

function PrivateRoute({ isPrivate = true, children, ...rest }) {
  const isLoggedIn = Boolean(getUser()?.access_token);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        // ✅ ruta pública
        if (!isPrivate) return children;

        // ✅ ruta privada y logueado
        if (isLoggedIn) return children;

        // 🔒 ruta privada sin login
        return (
          <Redirect to={{ pathname: '/login', state: { from: location } }} />
        );
      }}
    />
  );
}

export default PrivateRoute;
